import React from "react";
import HeroPage from "../ones/PageHero"; // Adjust path based on your file tree
import { 
  MdBusiness, 
  MdPerson, 
  MdBadge, 
  MdReceipt, 
  MdCardMembership, 
  MdMonetizationOn, 
  MdTerminal, 
  MdArrowForward 
} from "react-icons/md";
import CallToAction from "../ones/CallToAction";
import Footer from "../ones/Footer";

export default function TaxConsultancy() {
  const heroData = {
    kicker: "TRUSTED OVERSIGHT",
    title: "Advanced Tax Consultancy & Regulatory Blueprinting",
    description: "Navigating complex corporate tax laws, withholding obligations, and TRA frameworks with optimized solutions designed for absolute legal compliance and fiscal excellence."
  };

  const capabilities = [
    {
      icon: <MdBusiness />,
      title: "Corporate Tax",
      desc: "Accurate tax calculations, proactive structural planning, and timely preparation and filing of annual corporate income returns to the TRA."
    },
    {
      icon: <MdPerson />,
      title: "Personal Tax",
      desc: "Tailored tax planning and optimization strategies for high-net-worth business owners and executives to support compliance and asset protection."
    },
    {
      icon: <MdBadge />,
      title: "Employment Tax",
      desc: "Rigorous administrative oversight of PAYE, Skills Development Levy (SDL), and statutory social security obligations to prevent compliance penalties."
    },
    {
      icon: <MdReceipt />,
      title: "VAT Returns",
      desc: "Value Added Tax calculations, monthly reconciliation, and Electronic Fiscal Device (EFD) verification to manage your input-output credits smoothly."
    },
    {
      icon: <MdCardMembership />,
      title: "Tax Exemptions",
      desc: "Strategic processing and legal documentation setup to secure investment tax exemptions via the Tanzania Investment Centre (TIC) or TRA pathways."
    },
    {
      icon: <MdMonetizationOn />,
      title: "Withholding Taxes",
      desc: "Diligent management of withholding tax allocations on domestic contracts, cross-border transactions, interest payouts, and dividend distribution."
    }
  ];

  return (
    <div className="service-details-page-wrapper">
      <HeroPage data={heroData} />

      <section className="service-overview-section py-5">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-7" data-aos="fade-right">
              <span className="overview-kicker text-secondary text-uppercase font-weight-bold tracking-wider">Fiscal Management</span>
              <h2 className="overview-title text-primary font-weight-bold mt-2">Proactive Tax Engineering to Mitigate Risk</h2>
              <p className="overview-paragraph text-muted-narrative mt-3">
                Tax environments require diligent oversight to avoid operational delays. We serve diverse accounts ranging from development-stage firms to established corporations, providing clear compliance solutions for local businesses.
              </p>
            </div>
            <div className="col-lg-5" data-aos="fade-left">
              <div className="overview-sidebar-card border p-4 rounded bg-white shadow-sm">
                <h4 className="text-primary font-weight-bold border-bottom pb-2 mb-3">Service Brief</h4>
                <ul className="sidebar-bullet-list list-unstyled d-flex flex-column gap-2 mb-0">
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>TRA EFD System Alignment</span></li>
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>TIC Incentive Processing</span></li>
                  <li className="d-flex align-items-center gap-2"><MdTerminal className="text-secondary" /> <span>Statutory Filing Assurance</span></li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="service-capabilities-section py-5 bg-light-surface-tint">
        <div className="container">
          <div className="section-title-area text-center mb-5" data-aos="fade-up">
            <h2 className="text-primary font-weight-bold">Core Scope of Operations</h2>
            <div className="kicker-line mx-auto bg-secondary mt-2" />
          </div>

          <div className="row g-4 justify-content-center">
            {capabilities.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index} data-aos="fade-up" data-aos-delay={index * 50}>
                <div className="premium-capability-card h-100 bg-white p-4 border rounded shadow-sm d-flex flex-column">
                  <div className="capability-icon-box text-primary mb-3 fs-2">{item.icon}</div>
                  <h3 className="capability-title text-primary font-18 font-weight-bold mb-2">{item.title}</h3>
                  <p className="capability-desc text-muted mb-0 font-14 flex-grow-1">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="service-cta-banner bg-primary text-white text-center py-5">
        <div className="container py-3" data-aos="zoom-in">
          <h2 className="font-weight-bold mb-3">Establish a Clear Tax Strategy</h2>
          <p className="max-w-600 mx-auto text-light-opacity mb-4">
            Avoid unforeseen audit disruptions and secure corporate incentives. Connect with our senior consultants.
          </p>
          <button className="btn btn-secondary text-primary font-weight-bold px-4 py-2 border-0">
            Initiate Tax Review <MdArrowForward className="ms-1" />
          </button>
        </div>
      </section>

      <CallToAction />
      <Footer />
    </div>
  );
}